import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useValidateAddress({ token }) {
  const mutation = useMutation({
    mutationKey: ['validate-address', token],
    mutationFn: async (params) => {
      const data = await handleFetchResponse(
        fetch(getApiUrl('energia-solar/v2/entry/validate-address'), {
          method: 'POST',
          body: JSON.stringify(params),
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
